// extracted by mini-css-extract-plugin
export default {"cls1":"VeloFileUpload-Icon_cls1__MiwZp","cls2":"VeloFileUpload-Icon_cls2__Mw5wh VeloFileUpload-Icon_cls1__MiwZp"};